import * as React from 'react'
import styled, { css } from 'styled-components'

type TProps = {
  type?: 'feed' | 'modal' | 'card'
  className?: string
}

const NewsItemHeaderLoading: React.FC<TProps> = ({ type, className }) => {
  return (
    <>
      <StyledWrapper
        className={className}
        data-type={type}
        size={type === 'modal' ? 40 : 50}
      >
        <div className="lt">
          <div className="cover-image-box"></div>
          <div className="content">
            <div className="channel-name"></div>
            <div className="channel-info"></div>
          </div>
        </div>
        {(type === 'feed' || type === 'card') && <div className="rt"></div>}
      </StyledWrapper>
    </>
  )
}

export default NewsItemHeaderLoading

const StyledWrapper = styled.div<{
  size: number
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px 12px;
  .lt {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    .cover-image-box {
      ${({ size }) => css`
        border-radius: 5px;
        background-color: #eeeeee;
        width: ${size}px;
        height: ${size}px;
      `}
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .channel-name {
      height: 16px;
      border-radius: 5px;
      background-color: #eee;
      width: 150px;
      margin-bottom: 2px;
    }
    .channel-info {
      height: 14px;
      border-radius: 5px;
      background-color: #eee;
      width: 100px;
    }
  }
  .rt {
    height: 25px;
    border-radius: 5px;
    background-color: #eee;
    width: 25px;
    margin-bottom: 2px;
  }

  &[data-type='modal'] {
    .rt {
      flex-shrink: 0;
      align-self: stretch;
    }
  }
  &[data-type='card'] {
    .rt {
      flex-shrink: 0;
      align-self: stretch;
    }
  }
`
